import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogFooter, DialogHeader, DialogTitle } from '../../../../common/components/ui/dialog.tsx';
import { LoadingButton } from '../../../../common/components/LoadingButton';
import { ScrollArea } from '../../../../common/components/ui/scroll-area';

export function NotCurrentCartDialog() {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  function handleShoppingCartReload() {
    setIsLoading(true);
    window.location.reload();
  }

  return (
    <>
      <DialogHeader>
        <DialogTitle className={'flex items-center mb-0'}>{t('Warenkorb nicht mehr aktuell')}!</DialogTitle>
      </DialogHeader>
      <ScrollArea className="overflow-y-auto">
        <div>
          {t('Der Warenkorb wurde bereits weiterverarbeitet. Bitte aktualisieren Sie die Seite, um Ihren aktuellen Warenkorb zu sehen')}!
        </div>
      </ScrollArea>
      <DialogFooter className={'mt-4 flex-col desktop:flex-row gap-4 desktop:gap-1'}>
        <LoadingButton loading={isLoading} onClick={handleShoppingCartReload} data-testid={'cart-reload-button'}>
          {t('Seite neu laden')}!
        </LoadingButton>
      </DialogFooter>
    </>
  );
}
